import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import VueLazyload from "vue-lazyload";
import PortalVue from "portal-vue";
import { i18n } from "@/localization";
import VueToggles from "vue-toggles";
import VueToast from "vue-toast-notification";

import "@/registerServiceWorker";
import "vue-toast-notification/dist/theme-sugar.css";
import "@/assets/scss/app.scss";
import "@/assets/svg/index";
// @ts-ignore
import tooltip from "@/components/layouts/tooltip";

Vue.config.productionTip = false;

Vue.use(VueToast);
Vue.use(PortalVue);
Vue.use(VueLazyload);

Vue.component("VueToggles", VueToggles);
Vue.component("tooltip", tooltip);

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
  data() {
    return {
      selectedGroup: undefined,
      selectedTrunk: undefined,
    };
  },
  methods: {
    parseApiError(e: any): string {
      if (e) {
        if (e.response) {
          if (e.response.data) {
            if (e.response.data.id) {
                
                //@ts-ignore
                if (this.$te(`errors.${e.response.data.id}`)) {
                //@ts-ignore
                return this.$t(`errors.${e.response.data.id}`, e.response.data.fmt);
              }
            }
          }
        } else if (e.id) {
          //@ts-ignore
          if (this.$te(`errors.${e.id}`)) {
            //@ts-ignore
            return this.$t(`errors.${e.id}`, e.fmt);
          }
        }
      }
      return this.$t("views.messages.general_error") as string;
    },
    pushOrSlice(array: Array<string | number>, prop: string | number) {
      if (array.includes(prop)) {
        array.splice(array.indexOf(prop), 1);
      } else {
        array.push(prop);
      }

      return array;
    },
    globalGroupSelected(group?: Group) {
      //@ts-ignore
      this.selectedGroup = group;
      this.selectedTrunk = undefined;
    },
    globalTrunkSelected(trunk?: Trunk) {
      //@ts-ignore
      this.selectedTrunk = trunk;
      this.selectedGroup = undefined;
    },
  },
}).$mount("#app");
